<template>
  <div class="animated fadeIn list-of-advance">
    <b-card>
      <div slot="header">List of Adjustment  - Expense Reimbursment 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="posting()">
              <i class="fa fa-paper-plane"></i> Posting
          </button>
          <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print Jv
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i>
            Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>

      <b-row v-if="showFilter" >
        <b-col md="6">
          <b-input-group >
              <b-input-group-prepend><label>ADJ. Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>ADJ. Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.nomor" placeholder=" % for wildcard" style="width:25% !important;"></b-form-input>
              <b-input-group-prepend><span class="pt-2">AP Number &nbsp;</span></b-input-group-prepend>
              <b-form-input v-model="tblData.nomorap" placeholder="AP Number" style="width:25% !important;"></b-form-input>
              <b-input-group-prepend><span class="pt-2">Posting &nbsp;</span></b-input-group-prepend>
              <b-form-select v-model="tblData.status" :plain="true" :options="dataList.postingStatus"></b-form-select>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
              <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
                <b-form-input v-model="tblData.uraian" placeholder="Description" class="ml-1"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="6">
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>ADJ.Account</label></b-input-group-prepend>
                <b-form-input v-model="tblData.kodeacc" placeholder="Account code" ></b-form-input>
                <b-form-input v-model="tblData.kodeacc" placeholder="Account Name" class="ml-1"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
              <b-input-group-append>
                    <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
              </b-input-group-append>
              <b-input-group-append>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>           
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked" 
      >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tglRequ)="data">
          {{ data.item.tglRequ | moment("D-MMM-YY") }}
        </template>
        <template v-slot:cell(jumlah)="data">
          {{data.item.matauangar}}
          {{data.item.jumlah|numFormat}}
        </template>
        <template v-slot:cell(nilaibayar)="data">
          {{data.item.nilaibayar|numFormat}}
        </template>
        <template v-slot:cell(nilaibank)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{(data.item.nilaibank)|numFormat}}
          </div>
          <div v-else> 
            {{(data.item.nilaibank)|numFormat}}
          </div>
        </template>

      </b-table>
      <b-row >
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols-lg=2 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>

  </div>
</template>



<script>
import apadjust from '../../apis/expenAdjust';
import dropdown from "../../data/dropdown";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();


export default {
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      isprintjv:false,
      model: {},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'tanggal',
        sortDesc: true,
        DimCol:'Dim1',settl_amt:'1'
      },
      pagination: false,
      dataList: {
        postingStatus: dropdown.postingStatus
      }      
    };
  },
  components: {Loading},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:80px",
            label: "Trx. Date",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "glAccount",
            label: "Destination Acc.",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "nomorExpen",
            label: "ER Number",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "tglRequ",
            label: "Invoice Date",
            thStyle: "width:80px",
          },
          {
            key: "crewinfo",
            label: "Employee",
            thStyle: "width:200px",
          },
          {
            key: "keterangan",
            label: "ER Description",
          },
          {
            key: "jumlah",
            label: "ER Amount Due (Original)",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "nilaibayar",
            label: "Adjustment Amount (Original)",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "nilaibank",
            label: "Adjustment LCY Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          }
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     thStyle: "width:100px",
        //     label: dims[i].text
        //   },)
        // }

        // fields.push({
        //     key: "action",
        //     label: "Action",
        //     thClass: "text-center",
        //   });
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.erAdjlist) {
            this.tblData[key] = filter.erAdjlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.erAdjlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.erAdjlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await apadjust.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await apadjust.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    search(ctx) {
      this.tblData.page=1;
      this.$refs.table.refresh();
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.namaacc= '';
        this.tblData.kodeacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimVal','tgl1', 'tgl2','status', 'nomor', 'vendor', 'kodeacc', 'namaacc'];
      let filtered = false;
      const erAdjlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              erAdjlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          erAdjlist.page=this.tblData.page;
          erAdjlist.limit=this.tblData.limit;
          erAdjlist.sortBy=this.tblData.sortBy;
          erAdjlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.erAdjlist=erAdjlist;
          this.$store.commit("filter", filter);
      }
    },     
    add(){
      this.saveFilter();
      router.push({name :"advance.expreimbursAdjfrm"});
    },
    edit: function() {
        if (this.model.erAdjttKey) {
        this.saveFilter();
          router.push({name :'advance.expreimbursAdjfrm', params: { erAdjttKey: this.model.erAdjttKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    editjv: function() {
        if (this.model.erAdjttKey) {
            this.saveFilter();
            const tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
          router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomor, tanggal, kodejurnal:'APADJ'}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },    
    deleteConfirm() {
        if (this.model.erAdjttKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await apadjust.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.erAdjttKey==this.model.erAdjttKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      // if (this.model.erAdjttKey == record.erAdjttKey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    posting: async function () {
        if (this.model.erAdjttKey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
              await apadjust.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await apadjust.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },      
    printjv: async function()
    {
      if (this.model.erAdjttKey) {
          try {
                this.showReport=true;
            this.isprintjv=true;
              this.reportUrl= await apadjust.printjv(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await apadjust.exportXls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/payable/home");
    }
  }
};
</script>
